import _ from 'lodash';

const processStrategy = (address) => {
  const relations = {};
  const omit = [];
  return { ..._.omit(address, omit), ..._.pickBy(relations, _.identity) };
};

export default {
  key: 'address',
  definition: {},
  processStrategy,
};
